import Vue from 'vue';
import routerPageHook from '@assets/js/routerPageHook.js'
import BannerBtn from '@components/ui-components/banner-btn/component.js';
import Quote from '@components/ui-components/quote/component.js';
import SliderView from '@components/ui-components/slider-view/component.js';
import tagsBlock from '@components/ui-components/tags/tags.vue';
import formGreen from '@components/base/form-green.vue';
import VideoBlock from '@components/ui-components/video-block/component.js';
import { mapState } from "vuex";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
        }
    },
    components: {
        'form-green-cmp': formGreen,
        'banner-btn-cmp': BannerBtn,
        'quote-cmp': Quote,
        'slider-view-cmp': SliderView,
        'tags-cmp': tagsBlock,
        'video-block-cmp': VideoBlock,
    },
    computed: {
        ...mapState('mobile', ['isMobile']),
    },
    methods: {
        getName(name) {
            let mass = name.split(' ');
            mass = mass.filter((item, index) => index < 2);
            let result = '';
            mass.forEach((item) => {
                result = result + item.split('')[0];
            });
            return result;
        }
    },
    ...routerPageHook,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/cases/view/index.js